import React, { createContext, useState } from "react";

export const GlobalContext = createContext();

const GlobalProvider = (props) => {
  
    const token = localStorage.getItem("token");


  return (
    <GlobalContext.Provider value={{ 
        token
     }}>
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;
